import axios from 'axios';

function getIpCurrency() {
  return axios.get(`https://ipapi.co/currency`);
}

export default {
  getIpCurrency,
};
